import React, { useContext } from 'react';
import { useEffect } from 'react';
import { BrokenCard } from 'src/assets/images';
import { publicSiteUrl } from 'src/common';
import {
  ApplicationActionType,
  ButtonConfig,
  LayoutType,
  useWizardEffect,
} from 'src/features/common';
import ButtonGroup from 'src/features/common/components/button-group/revamp-button-group';
import {
  ButtonParamType,
  DefaultButtonStyle,
} from 'src/features/common/components/button/revamp-button';
import { killApplication } from 'src/features/common/reducers/application/application-reducer-helpers';
import { ApplicationContext } from '../../context';
import { useAsyncDispatch } from '../../hooks/use-async-dispatch';
import './failure-page.scss';

export type FailurePageProps = {
  onFailurePageShow?: () => void;
  onFailurePageDispatch?: () => void;
  errorMessage?: string;
};

export const FailurePage = (props: FailurePageProps) => {
  const { application, dispatch, salesforceService, catalogue } = useContext(ApplicationContext);
  const dispatchAsync = useAsyncDispatch(application, dispatch);

  const { setLoadingOverlayVisible } = useWizardEffect(() => ({ footerVisible: false }), []);

  const cancelApplication = async () => {
    setLoadingOverlayVisible(true);
    const updatedApp = await dispatchAsync({
      type: ApplicationActionType.KILL_APPLICATION,
    });

    await salesforceService.saveApplication(killApplication(updatedApp, catalogue), true);
    setLoadingOverlayVisible(false);

    window.location.href = publicSiteUrl;
  };

  useEffect(() => {
    if (props.onFailurePageShow) {
      props.onFailurePageShow();
    }
  }, []);

  const businessRegistrationButton: ButtonConfig = {
    automationId: 'Revamp_Order_OutCome_Retry_Button',
    label: 'Retry',
    className: 'retry-button',
    buttonStyle: DefaultButtonStyle()
      .hasPrimaryAction()
      .isLargeSize()
      .hasDarkMode()
      .isResponsive()
      .build(),
    buttonParams: {
      type: ButtonParamType.NormalButton,
      onClick: () => {
        if (props.onFailurePageDispatch) {
          props.onFailurePageDispatch();
        }
      },
    },
  };

  const cancelAppButton: ButtonConfig = {
    automationId: 'Revamp_Order_Outcome_CancelApp_Button',
    label: 'Cancel Application',
    className: 'retry-button',
    buttonStyle: DefaultButtonStyle()
      .hasSecondaryAction()
      .isLargeSize()
      .hasDarkMode()
      .isResponsive()
      .build(),
    buttonParams: {
      type: ButtonParamType.NormalButton,
      onClick: cancelApplication,
    },
  };

  return (
    <article className="failure-page">
      <img src={BrokenCard} />
      <h1>Payment failed</h1>
      <p className="spacer-below">
        {props.errorMessage ? (
          props.errorMessage
        ) : (
          <>
            We are unable to process your payment. <br />
            If you think this is an error, please try again. <br />
            Alternatively, please contact your bank for further assistance.
          </>
        )}
      </p>
      <ButtonGroup
        buttons={[businessRegistrationButton, cancelAppButton]}
        layoutType={LayoutType.CENTERED}
      />
    </article>
  );
};
